import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faGear,
  faCheckToSlot,
  faUserTie
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { RootState } from 'store/rootReducer';

interface IParagraph {
  label: string;
  value: string | undefined;
  icon: IconProp;
}

const Paragraph = ({ label, value, icon }: IParagraph) => {
  return (
    <div className="d-flex justify-content-between align-items-center border-bottom border-dashed py-4">
      <div className="d-flex gap-3 align-items-center">
        <FontAwesomeIcon icon={icon} className="text-body-quaternary" />
        <h5 className="m-0">{label}</h5>
      </div>
      <h5 className="m-0">{value ?? '-'}</h5>
    </div>
  );
};

const CandidateProfileInfoCard = () => {
  const user = useSelector((state: RootState) => state.user.user);
  return (
    <Card className="h-100">
      <Card.Body>
        <div className="border-bottom">
          <h4 className="mb-3 lh-sm lh-xl-1">Account Information</h4>
        </div>
        <article>
          <Paragraph
            label="Overall experience"
            value={
              user.info.experience?.overallYear
                ? `${user.info.experience?.overallYear} Year`
                : undefined
            }
            icon={faGear}
          />
          <Paragraph
            label="Availability"
            value={user.info.jobAvailability?.preference}
            icon={faCheckToSlot}
          />
          <Paragraph
            label="Role and current earnings"
            value={user.info.role?.value}
            icon={faUserTie}
          />
        </article>
      </Card.Body>
    </Card>
  );
};

export default CandidateProfileInfoCard;
